import React from "react";

export default function AboutProjectFr() {
  return (
    <div style={{ maxWidth: 880, marginTop: 40, marginBottom: 40, padding: 24 }}>

      <h1 style={{ fontWeight: 900, fontSize: 36, marginBottom: 28 }}>
        À propos de Radiomonitor.net
      </h1>
      <p style={{ fontSize: 18, marginBottom: 34 }}>
        <b>Radiomonitor.net</b> est une plateforme analytique moderne pour la radio en ligne, offrant contrôle total, monitoring et analyse approfondie de votre audience en temps réel. Le service est conçu pour les stations qui souhaitent comprendre leur audience, renforcer la fidélité des auditeurs et mesurer précisément l'efficacité de l'antenne et des campagnes publicitaires.
      </p>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🛠️ Modules prêts à l'emploi
      </h2>
      <p style={{ marginBottom: 12 }}>
        Notre système propose une série de modules puissants :
      </p>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li>🧑‍💻 <b>Generic Listeners</b> — vue des auditeurs actifs avec filtres, tri et actualisation automatique ;</li>
        <li>📍 <b>Geo-analytique</b> — cartes et tableaux répartissant l'audience par pays et villes ;</li>
        <li>📊 <b>Generic Live & Count</b> — tableau en ligne avec données en direct et compteur dédié ;</li>
        <li>📈 <b>Reklama Stats</b> — statistiques détaillées d'écoute des blocs publicitaires ;</li>
        <li>📉 <b>TSL Analytics</b> — module de durée moyenne d'écoute ;</li>
        <li>🆕 <b>New Cases</b> — détection des nouvelles IP/UA et séparation des connexions réelles et techniques ;</li>
        <li>🗃️ <b>Aggregator</b> — agrégation centralisée des données issues de plusieurs sources ;</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        📌 Pourquoi nous choisir
      </h2>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li><b>Flexibilité :</b> fonctionne avec Icecast, Shoutcast, HLS, Wowza et d'autres serveurs ;</li>
        <li><b>Précision :</b> utilise les métriques industrielles — AQH, TSL, Cume, AAS, TLH, GRP, etc. ;</li>
        <li><b>Temps réel :</b> statistiques en ligne sans latence ;</li>
        <li><b>Sécurité :</b> plateforme autonome n'exigeant aucun SaaS ou API externe ;</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🚀 Amélioration continue
      </h2>
      <p style={{ fontSize: 18, marginBottom: 12 }}>
        Nous <b>améliorons en permanence</b> la plateforme en ajoutant :
      </p>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li>De nouvelles métriques (y compris les standards IAB, Nielsen) ;</li>
        <li>De nouvelles visualisations ;</li>
        <li>L'intégration avec des systèmes BI (Power BI, Data Studio, Grafana) ;</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🖥️ Rejoignez-nous
      </h2>
      <p style={{ fontSize: 18, marginBottom: 14 }}>
        Radiomonitor.net n'est pas seulement un compteur d'audience. C'est le <b>cerveau analytique</b> de votre station.
      </p>
      <p style={{ fontSize: 18 }}>
        Connectez-vous dès aujourd'hui et transformez vos données en décisions concrètes.
      </p>
    </div>
  );
}
